<template>
  <div class="card modal-overflow" style="box-shadow: none;">
    <div class="card-body new-job">
      <div class="row">
        <div class="col-md-5">
          <div class="form-group">
            <label>Task Name</label>
            <div class="view-fields grey-font">
              <h6>
                {{ task.name }}
              </h6>
            </div>
          </div>
        </div>
        <div class="col-md-1">
          <label>&nbsp</label>
          <img @click.stop="viewFiles" v-if="canReadFiles" src="static/img/icon-folder.png" title="Task Files" class="files-icon"/>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Owner</label>
            <div class="view-fields grey-font">
              {{ getUserDisplayName(task.ownerId) }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Assignee</label>
            <div class="view-fields grey-font">
              {{ getUserDisplayName(task.assigneeId) }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Priority</label>
            <div class="view-fields grey-font">
              {{ priorityValueToLabel(task.priority) }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Status</label>
            <div class="view-fields grey-font">
              {{ task.status }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Due Date</label>
            <div class="view-fields grey-font">
              {{ task.dueDate | formatDate }}
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Completion Date</label>
            <div class="view-fields grey-font">
              {{ task.completionDate | formatDate }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Notes</label>
            <div class="view-fields grey-font">
              <div v-html="task.notes">-</div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Extra Fields</label>
            <div class="view-fields grey-font">
              <ul>
                <li v-for="fieldKey in Object.keys(task.fieldValues)">{{ getTaskFieldKeyLabel(fieldKey) }}: {{ task.fieldValues[fieldKey] }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {OK, NOT_FOUND} from 'http-status-codes'
import {getRepeatCount, fileSystemPathForTask, formatTaskFieldKey, notifyError, priorityLabel} from 'src/utilities/utils'
import {mapGetters} from 'vuex'
import Constants from 'src/utilities/constants'
import lodash from "lodash"
import Permissions from 'src/utilities/permissions'

export default {
  props: ['data'],
  computed: {
    ...mapGetters({
      taskTemplates: 'tasks/templates/results'
    }),
    canReadFiles() {
      return this.$can('read', Permissions.FILES)
    }
  },
  data() {
    return {
      lodash,
      task: {
        fieldValues: {}
      }
    }
  },
  methods: {
    priorityValueToLabel(value) {
      return priorityLabel(value)
    },
    getUserDisplayName(userId) {
      return this.$store.getters['users/displayName'](userId)
    },
    getTaskFieldKeyLabel(fieldKey) {
      return formatTaskFieldKey(this.taskTemplates, this.task, fieldKey)
    },
    async viewFiles() {
      const responseJob = await this.$store.dispatch('fetchById', {endpoint: 'jobs', id: this.task.jobId})
      if (OK !== responseJob.status) {
        notifyError(this, "Failed to load job by ID: " + this.task.jobId)
        return
      }

      const departmentResponse = await this.$store.dispatch('departments/fetchById', responseJob.data.departmentId)
      if (OK !== departmentResponse.status) {
        notifyError(this, "Failed to load department by ID: " + responseJob.data.departmentId)
        return
      }

      const projectResponse = await this.$store.dispatch('projects/fetchById', this.task.projectId)
      if (OK !== projectResponse.status) {
        notifyError(this, "Failed to load project by ID: " + this.task.projectId)
        return
      }

      const reinspectionCount = getRepeatCount(this.task)
      const path = fileSystemPathForTask(projectResponse.data.name, this.task.projectId, departmentResponse.data.name, responseJob.data.name, responseJob.data.id, this.task.name, this.task.id, reinspectionCount)
      this.$eventHub.$emit('show-modal-4', 'File Browser', path, '600px')
    },
  },
  async beforeMount() {
    if (!lodash.get(this.data, 'id')) {
      notifyError(this, 'The `this.data.id` prop is missing. Unable to load task data.')
      return
    }

    await this.$store.cache.dispatch('tasks/templates/fetchAll')

    const response = await this.$store.dispatch('fetchById', {
      'endpoint': Constants.ENTITY_ENDPOINTS.TASKS,
      'id': this.data.id
    })

    if (OK === response.status) {
      this.task = response.data
    } else if (NOT_FOUND === response.status) {
      notifyError(this, 'Failed to load task. Task with ID: ' + this.data.id + ' was not found')
    } else {
      notifyError(this, 'Failed to load task')
    }
  }
}
</script>

<style scoped>
.view-fields {
  background-color: lightgrey;
  padding: 11px 0 4px 8px;
  border-radius: 5px;
  min-height: 40px;
}
label {
  display: block;
}
.files-icon {
  cursor: pointer;
  margin-top: 8px;
}
</style>
